/**
 * 데이터 무관(data-free) 카탈로그 래퍼.
 *
 * 이 모듈은 빌드 타임 생성물 `catalog.data.json`(questions 제거된 메타데이터)과
 * 타입 전용 import 만 사용한다. 절대 `./tests/*` JSON 이나 배럴(`./index`) 의
 * 값(value) 을 정적 import 하지 않는다 — 그렇게 하면 전체 테스트 데이터가
 * 초기 번들로 끌려오기 때문이다. 이게 이 모듈의 존재 이유다.
 */
import data from "./catalog.data.json";
// i18n/en 은 ../index 를 타입 전용으로만 import 하므로 테스트 데이터를 끌어오지 않는다.
import {
  EN_CATEGORY_LABELS,
  getEnglishTestDescription,
  getEnglishTestTitle,
} from "./i18n/en";
// 타입 전용 import — 빌드 시 erase 되어 데이터를 끌어오지 않는다.
import type { TestCategory, TestDefinition } from "./index";
export { NEW_WINDOW_DAYS, isNewTest } from "./new-test";

export type TestMeta = Omit<TestDefinition, "questions"> & {
  questionCount: number;
};

export const catalog = data.tests as TestMeta[];

export const TEST_CATEGORIES = data.categories as {
  id: TestCategory;
  label: string;
}[];

export function getLocalizedCatalog(locale: "ko" | "en"): TestMeta[] {
  return locale === "ko" ? catalog : catalog.map(localizeTestMetaToEnglish);
}

export function getLocalizedCatalogCategories(locale: "ko" | "en") {
  return locale === "ko"
    ? TEST_CATEGORIES
    : TEST_CATEGORIES.map((category) => ({
        ...category,
        label: EN_CATEGORY_LABELS[category.id],
      }));
}

/**
 * createdAt 이 최근 NEW_WINDOW_DAYS 일 이내면 true.
 * createdAt 이 없거나, 미래거나, 파싱 불가면 false.
 *
 * NOTE: index.ts 의 isNewTest 와 동일한 구현을 의도적으로 복제했다.
 * 이 모듈을 data-free 로 유지하기 위해 배럴(index.ts) 을 import 하지 않는다.
 */
/**
 * ko 메타를 영문 표시용으로 변환. questions 없이 questionCount 로 설명을 만들어
 * data-free 를 유지한다(전체 로컬라이즈는 배럴의 localizeTestToEnglish 사용).
 */
export function localizeTestMetaToEnglish(meta: TestMeta): TestMeta {
  return {
    ...meta,
    title: getEnglishTestTitle(meta),
    description: getEnglishTestDescription(meta, meta.questionCount),
  };
}
